import { HELP_URL } from '@/config/env'
import { getMobiwayCountry } from '@/lib/axios'
import { AvailableCountry } from '@/types/openapi'

// Reserved key used as the fallback link when the current country has no dedicated entry.
export const HELP_DEFAULT_KEY = 'default'

type HelpUrlMap = Partial<Record<AvailableCountry | typeof HELP_DEFAULT_KEY, string>>

/**
 * Resolves the help/tutorial URL for the app's current country.
 *
 * `VITE_APP_HELP_URL` holds a JSON map of country -> URL (plus an explicit `default` entry).
 *
 * Resolution order:
 * 1. The URL declared for the current country.
 * 2. The explicit `default` entry.
 * 3. An empty string (callers should hide the entry point when empty rather than render a dead link).
 *
 * Returns an empty string when the variable is missing or contains invalid JSON.
 */
export function getHelpUrl(): string {
  let map: HelpUrlMap = {}

  try {
    map = JSON.parse(HELP_URL || '{}')
  } catch {
    map = {}
  }

  const country = getMobiwayCountry()

  return (country && map[country]) || map[HELP_DEFAULT_KEY] || ''
}
